// Client-side Sentry init (Next.js `instrumentation-client` convention — runs
// after the HTML document loads, before hydration).
import * as Sentry from "@sentry/nextjs";
import { SENTRY_DSN } from "@/lib/config";

Sentry.init({
  dsn: SENTRY_DSN,
  enabled: Boolean(SENTRY_DSN),
  environment: process.env.NODE_ENV,
  // 100% client tracing to match the React app's posture
  // (apps/frontend/src/main.tsx). This feeds Sentry's Web Vitals view
  // (LCP/CLS/FCP/INP/TTFB) — which is why PostHog `$web_vitals` is disabled
  // in PostHogProvider.tsx.
  tracesSampleRate: 1.0,
  // The landing page reports into the same Sentry project as the React app
  // (dd-ai-agent) — this tag is how landing events are told apart.
  initialScope: { tags: { service: "landing-page" } },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
